import { useRef, useLayoutEffect } from 'react';

export function DangerousHTML({ html }) {
	const elRef = useRef<HTMLDivElement>();

	useLayoutEffect(() => {
		const range = document.createRange();
		range.selectNode(elRef.current);
		const documentFragment = range.createContextualFragment(html);

		// Inject the html, triggering a re-run!
		elRef.current.innerHTML = '';
		elRef.current.append(documentFragment);

    /*questo pezzo di codice serve per triggerare l'evento DOMContentLoaded (se gestito dagli script scaricati dall'html) quando si sta
    facendo la navigazione client-side perchè in quel caso l'evento DOMContentLoaded è scattato molto prima (magari al load della pagina precedente)*/
    var DOMContentLoaded_event = document.createEvent("Event");
    DOMContentLoaded_event.initEvent("DOMContentLoaded", true, true);
    window.document.dispatchEvent(DOMContentLoaded_event);
	}, []);

	return (
		<div ref={elRef} dangerouslySetInnerHTML={{ __html: html }}/>
    );
}

export default DangerousHTML;
